<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="12"> 套餐操作日志详情 </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="操作类型">
            {{formInline.operationType}}
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="新数据">
            <a-textarea style="height: 300px" v-model="formInline.newData"></a-textarea>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="旧数据">
            <a-textarea style="height: 300px" v-model="formInline.oldData"></a-textarea>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="用户uid">
            {{formInline.uid}}
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="用户名称">
            {{formInline.userName}}
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="操作时间">
            {{formInline.createTime}}
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>

<script>
import { infoGoodsMallLog } from "@/api/storeApi.js";

export default {
  data() {
    return {
      formInline: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
    };
  },
  created() {
    this.getDetailTokensList();
  },
  methods: {
    goBack() {
      this.$router.push("/home/packageLog/packageLogHome");
    },
    getDetailTokensList() {
      let objId = this.$route.query.objId;
      infoGoodsMallLog(objId).then((res) => {
        console.log(res)
        this.formInline = res.data
      });
    },
  },
};
</script>

<style>
h1 {
  position: absolute;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/packageLog/packageLogInfo.vue